import { createSlice } from "@reduxjs/toolkit";
 
const initialState = {
  Head:  {
    "A_Transid": "",
    "A_Date": "",
    "A_Location": "",
    "Loc_Name": "",
    "A_Narration": "",
    "A_Status": "",
    "Confirm_Status": "",
    "CreatedBy": "",
    "CreatedDt": "",
    "ConfirmBy":"",
    "ConfirmDt":""
}
};


const SliceStockSetupChangeApprove = createSlice({
  name: "SliceStockSetupChangeApprove",
  initialState: { value: initialState },

  reducers: {
    Head_Set: (state, action) => {
      state.value.Head = action.payload;
    },
    StockSetupChangeApprove_Init: (state) => {
      state.value = initialState;
    },
  },
});

export const {Head_Set ,StockSetupChangeApprove_Init } =  SliceStockSetupChangeApprove.actions;
export default SliceStockSetupChangeApprove.reducer;
